import React, { JSX } from 'react';
import Scripts from 'src/Scripts';
import { PrimaryLayout, PrimaryLayoutProps } from '@greystar/ui';

const Layout = ({ layoutData, headLinks }: PrimaryLayoutProps): JSX.Element => (
  <>
    <Scripts />
    <PrimaryLayout layoutData={layoutData} headLinks={headLinks} />
  </>
);

export default Layout;
